// export default utils
let isSupportWebp = document ? supportWebp() : false
export function supportWebp () {
    const ele = document.createElement('canvas')
    ele.width = 1
    ele.height = 1
    return ele.toDataURL && ele.toDataURL('image/webp').indexOf('data:image/webp') === 0
}

export function viewImageNew (value, width, height) {
    let img = ''
    if (value) {
        img = `${value}?x-oss-process=image/resize,w_${width},h_${height}/quality,Q_100/format,${isSupportWebp ? 'webp' : 'jpg'}`
    }
    img = img.replace('http:', 'https:')

    return img
}